import { render, staticRenderFns } from "./travelRequestDetails.vue?vue&type=template&id=7608dfd2&scoped=true&"
import script from "./travelRequestDetails.vue?vue&type=script&lang=js&"
export * from "./travelRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./travelRequestDetails.vue?vue&type=style&index=0&id=7608dfd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608dfd2",
  null
  
)

export default component.exports